import "rxjs/add/operator/map";
import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { LocalStorageService } from "ngx-store";
import { Subscription, Observable } from "rxjs";
import { Router } from "@angular/router";
import { ScrollToBottomDirective } from "./chat.directive";
import {
  AngularFireUploadTask,
  AngularFireStorage
} from "@angular/fire/storage";
import { AngularFirestore } from "@angular/fire/firestore";
import { finalize, tap } from "rxjs/operators";
import { PushNotificationsService } from "ng-push";
import { EncryptionService } from "src/app/providers/encryption/encryption.service";
export interface ViewMemoriesItem {
  name: string;
  id: number;
}
@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.css"]
})
export class ChatComponent implements OnInit {
  images: any;
  theme: any;
  [x: string]: any;
  subscription: Subscription;
  memory: any = {};
  name = "chat now";
  position = "float-left";
  positionFromUser;
  messages = [];
  msgVal: string = "";
  itemsRef;
  itemsRefBackup;
  items = [];
  itemsBackup = [];
  username;
  itemsRefIMG;
  itemsImageList = [];
  itemsRefIMGBp;
  preview;
  loader = true;
  selectedItem;
  @Input() file: File;
  task: AngularFireUploadTask;
  percentage;
  snapshot: Observable<any>;
  // downloadURL: string;
  imagesCollection: any;
  uploadstatus;
  userId = "ePJnW6BKY0Yi8cya6DRE3QfwKpt2";
  lastSeen = '';
  downloadURL: Observable<string>;
  @ViewChild("scrollMe", { static: false }) ScrollToBottomDirective;
  themeActive = 'default';
  constructor(
    private afd: AngularFireDatabase,
    private ls: LocalStorageService,
    private router: Router,
    private storage: AngularFireStorage,
    private db: AngularFirestore, 
    public encryption:EncryptionService
  ) { 
    const dev = false;
    if (dev) {
      if ((this.ls.get("username") == "psm") || (this.ls.get("username") == "mad")) {
        this.themeRf = afd.list("theme-dev");
        this.itemsRef = afd.list("pschats-dev");
        this.itemsRefBackup = afd.list("pschatsBackup-dev");
        this.itemsRefIMG = afd.list("psimagetest-dev");
        this.itemsRefIMGBp = afd.list("psimagetestBackup-dev");
        this.items = this.itemsRef.snapshotChanges().map(changes => {
          // this.lastSeen = new Date().toISOString();
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsBackup = this.itemsRefBackup.snapshotChanges().map(changes => {
          // this.lastSeen = new Date().toISOString();
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsImageList = this.itemsRefIMG.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsRefIMGBp.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
      } else {
        this.itemsRef = afd.list("sample");
        this.itemsRefIMG = afd.list("sampleImg");
        this.items = this.itemsRef.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsImageList = this.itemsRefIMG.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
      }
    } else {
      if ((this.ls.get("username") == "psm") || (this.ls.get("username") == "mad")) {
        this.themeRf = afd.list("theme");
        this.itemsRef = afd.list("pschats");
        this.itemsRefBackup = afd.list("pschatsBackup");
        this.itemsRefIMG = afd.list("psimagetest");
        this.itemsRefIMGBp = afd.list("psimagetestBackup");
        this.items = this.itemsRef.snapshotChanges().map(changes => {
          // this.lastSeen = new Date().toISOString();
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsBackup = this.itemsRefBackup.snapshotChanges().map(changes => {
          // this.lastSeen = new Date().toISOString();
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsImageList = this.itemsRefIMG.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsRefIMGBp.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
      } else {
        this.itemsRef = afd.list("sample");
        this.itemsRefIMG = afd.list("sampleImg");
        this.items = this.itemsRef.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
        this.itemsImageList = this.itemsRefIMG.snapshotChanges().map(changes => {
          return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
        });
      }
    }
    this.itemsRefBackup = afd.list("pschatsBackup");
  }

  ngOnInit() {
    if (this.ls.get("username")) {
      this.username = this.ls.get("username");
      this.lastSeen = new Date().toISOString();
      // Use snapshotChanges().map() to store the key
      this.getChats();
      this.setTheme();
    } else {
      this.router.navigate(["/login"]);
    }
    this.theme = this.ls.get('theme');
    if (this.theme) {
      Object.keys(this.theme.properties).forEach((property) => {
        document.documentElement.style.setProperty(property, this.theme.properties[property]);
      });
    }
  }

  addItem() {
    const data = (<HTMLInputElement>document.getElementById("val")).value;
    if (data) {
      this.itemsRef.push({
        title: this.encryption.encrypt(data),
        name: this.username,
        timeStamp: new Date().toISOString(),
      });
      if ((this.ls.get("username") == "psm") || (this.ls.get("username") == "mad")) {
        this.itemsRefBackup.push({
          title: this.encryption.encrypt(data),
          name: this.username,
          timeStamp: new Date().toISOString(),
        });
      }
      (<HTMLInputElement>document.getElementById("val")).value = ""; 
    }
  }

  deleteItem(key: string) {
    this.itemsRef.remove(key);
  }

  deleteEverything() {
    const res = confirm('Are you sure, you want to delete all!');
    if (res) {
      this.itemsRef.remove();
    }
  }

  getChats() {
    this.loader = true;
    this.itemsRef.valueChanges().subscribe(chats => {
      this.loader = false;
      this.items = chats;
    });
  }

  setTheme() {
    if (this.themeRf) {
      this.themeRf.valueChanges().subscribe(theme => {
        this.oldThemeData = JSON.parse(JSON.stringify(theme));
        if (theme.length > 0) {
          const newArr = theme.filter(val => {
            if (val.theme.name === this.ls.get('username')) {
              return val;
            }
          });
          if (!newArr[0]) {
            return
          }
          if (newArr[0].theme.mode == 'light') {
            this.lightTheme();
            return;
          }
          if (newArr[0].theme.mode == 'dark') {
            this.darkTheme();
            return;
          }
          if (newArr.length > 0) {
            this.theme = newArr[0].theme;
            this.ls.set('theme', newArr[0].theme);
            if (this.theme && this.theme.properties) {
              Object.keys(this.theme.properties).forEach((property) => {
                document.documentElement.style.setProperty(property, this.theme.properties[property]);
              });
            }
          }
        }
      });
    }
  }

  encodeImageFileAsURL(element) {
    var file = element.target.files[0];
    var reader = new FileReader();
    reader.onload = e => {
      this.ls.set("psimg", reader.result);
    };
    this.preview = this.ls.get('psimg');
    // this.uploadstatus = 'uploading....';
    if (this.preview) {
      this.itemsRefIMG.push({
        img: this.preview
      });
      if (this.ls.get("username") == "psm" || "mad") {
        this.itemsRefIMGBp.push({
          img: this.preview
        });
      }
      element.target.value = [];
    }
    reader.readAsDataURL(file);
  }

  showTimestamp(val) {
    this.selectedItem = val;
  }

  isActive(snapshot) {
    return (
      snapshot.state === "running" &&
      snapshot.bytesTransferred < snapshot.totalBytes
    );
  }


  startUploadNew(event: FileList) {
    // The File object
    const file = event.item(0);
    const fileType = file.type.split('/')[0];
    // Client-side validation example
    // if (file.type.split('/')[0]) {
    //   console.error('unsupported file type :( ');
    //   return;
    // }
    // The storage path
    const path = `test1/${new Date().getTime()}_${file.name}`;

    // Totally optional metadata
    const customMetadata = { app: 'My AngularFire-powered PWA!' };

    // The main task
    this.task = this.storage.upload(path, file, { customMetadata });

    // Progress monitoring
    this.percentage = this.task.percentageChanges();
    this.snapshot = this.task.snapshotChanges().pipe(
      tap(snap => {
        if (snap.bytesTransferred === snap.totalBytes) {
          // Update firestore on completion
          this.db.collection('photos').add({ path, type: fileType, size: snap.totalBytes });
        }
      }),
      finalize(() => {
        this.downloadURL = this.storage.ref(path).getDownloadURL();
      })
    );

    this.storage.ref(path).getDownloadURL().subscribe((url) => {
    });
    // console.log('downloadURL', this.downloadURL, this.storage.ref(path).getDownloadURL().subscribe(val=> console.log(val));
    // event.value = []
    // The file's download URL
  }

  darkTheme() {
    this.themeActive = 'dark';
    document.documentElement.style.setProperty('--p-header', '#524d5a');
    document.documentElement.style.setProperty('--p-header-txt', '#ffffff');
    document.documentElement.style.setProperty('--p-background', '#28262a');
    document.documentElement.style.setProperty('--p-txt-color', '#ffffff');
    document.documentElement.style.setProperty('--p-chat-txt-bg', '#524d5a');
    document.documentElement.style.setProperty('--p-chat-rx-txt-bg', '#78828e');
    document.documentElement.style.setProperty('--p-input-txt-clr', '#d6caca');
    document.documentElement.style.setProperty('--p-menu-txt-clr', '#ccc');
  }

  lightTheme() {
    this.themeActive = 'light';
    document.documentElement.style.setProperty('--p-header', '#673ab7');
    document.documentElement.style.setProperty('--p-header-txt', '#ffffff');
    document.documentElement.style.setProperty('--p-background', '#28262a');
    document.documentElement.style.setProperty('--p-txt-color', '#ffffff');
    document.documentElement.style.setProperty('--p-chat-txt-bg', '#673ab7');
    document.documentElement.style.setProperty('--p-chat-rx-txt-bg', '#6c757d');
    document.documentElement.style.setProperty('--p-input-txt-clr', '#ccc');
    document.documentElement.style.setProperty('--p-menu-txt-clr', '#c5c4c4');
  }

  save(mode) {
    if (mode == 'dark') {
      this.darkTheme()
    } else {
      this.lightTheme();
    }
    const theme = {
      name: this.ls.get('username'),
      mode: mode,
      properties: {
      }
    }
    this.ls.set('theme', theme);
    if (this.oldThemeData && this.oldThemeData.length > 0) {
      this.themeRf.remove();
      this.oldThemeData.map(data => {
        if (data.theme.name === this.ls.get('username')) {
          return data.theme.mode = mode;
        }
        this.themeRf.push({
          theme: data
        });
      })
      return;
    }
    this.themeRf.push({
      theme: theme
    });
  }

}
